<script>
import { generateNewDolu, updateDoluPosts, updateOnePost, deleteOnePost, likeOnePost, createOnePostComment, deleteOnePostComment } from '@/services/MindMovieServices';
import { nextTick } from 'vue';


export default {
  props: [ 'postId', 'propPost', 'allCategories', 'allCategoriesByName' ],
  emits: [],
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      // The Post
      post: {},
      youTubeStartTime: '',
      postLiked: false,
      lastTap: 0,
      TAP_DELAY: 300, // milliseconds
      // Form: Edit Post
      showForm: false,
      formType: '',
      formSrc: '',
      formStartTime: '',
      formCategories: [], // this is an array of selected categories' NAMES
      // Post Comments
      showCommentsSection: false,
      newComment: '',
    };
  },
  computed: {
    commentDate() {
      const today = new Date();
      // const formattedDate = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;
      // console.log(formattedDate);
      return `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;
    },
    formCategoriesCleaned() {
      let categories = [];
      for (let c of this.formCategories) {
        categories.push(this.allCategoriesByName[c]);
      }
      return categories;
    },
  },
  methods: {
    async loadImgurScript() {
      const s = document.createElement('script');
      s.src = `https://s.imgur.com/min/embed.js?cb=${Date.now()}`;
      s.async = true;
      await nextTick();
      document.body.appendChild(s);
    },
    userClickedEdit() {
      this.showForm = true;
    },
    async cancelEditPost() {
      this.showForm = false;
      this.formType = this.post.type;
      this.formSrc = this.post.src;
      this.formStartTime = this.post.startTime;

      this.formCategories = [];
      if (this.post.categories) {
        for (let c of this.post.categories) {
          this.formCategories.push(this.allCategories[c].name); // this pushes the category's NAME
        }
      }
    },
    async deletePost() {
      // console.log('*** delete post ***', this.postId, this.post);
      await deleteOnePost(this.uId, this.token, this.postId);
      await updateDoluPosts(this.uId, this.token, generateNewDolu());
      const p = document.getElementById(`single-post-${this.postId}`);
      if (p) {
        p.classList.add('d-none');
      }
      this.showForm = false;
    },
    async updatePost() {
      // create obj
      let updatedPost = {
        type: this.formType,
        src: this.formSrc,
        categories: this.formCategoriesCleaned,
      };
      if (this.formStartTime) {
        updatedPost.startTime = this.formStartTime.trim();
      }
      if (this.post.likes !== undefined) {
        updatedPost.likes = this.post.likes;
      }
      if (this.post.comments) {
        updatedPost.comments = this.post.comments;
      }
      console.log('*** SinglePost.updatePost() >> postId, post, updatedPost ***', this.postId, this.post, updatedPost);

      // API call
      const postWasUpdated = updateOnePost(this.uId, this.token, this.postId, updatedPost);

      // update UI
      if (postWasUpdated) {
        // update doluPost in dbase
        await updateDoluPosts(this.uId, this.token, generateNewDolu());
        // update UI, by updating data vars
        await this.cancelEditPost();
        this.post = updatedPost;
        this.formCategories = [];
        if (this.post.categories) {
          for (let c of this.post.categories) {
            this.formCategories.push(this.allCategories[c].name); // this pushes the category's NAME
          }
        }
        // console.log('*** updated FormCategories ***', this.formCategories);
        // console.log('*** updated post ***', this.formCategories);
      }
    },
    async doubleTappedThisPost() {
      // create newLikes
      let newLikes = this.post.likes;
      newLikes = this.postLiked ? newLikes - 1 : newLikes + 1;

      // console.log('*** SinglePost >> doubleTappedThisPost() >> newLikes ***', newLikes, this.postId);
      // API call
      const postWasUpdated = await likeOnePost(this.uId, this.token, this.postId, newLikes);

      // update the UI, updateDoluPosts(uId, token, doluString)
      if (postWasUpdated) {
        this.post.likes = newLikes;
        this.postLiked = !this.postLiked;
        await updateDoluPosts(this.uId, this.token, generateNewDolu());
      }
    },
    handleTouch() {
      console.log('*** starting handleTouch() ***');
      const currentTime = Date.now()
      const tapLength = currentTime - this.lastTap

      if (tapLength < this.TAP_DELAY && tapLength > 0) {
        // console.log('woohoo!')
        this.doubleTappedThisPost();
      }

      this.lastTap = currentTime
    },
    async leaveAComment() {
      // console.log('*** SinglePost >> leaveAComment() >> postId, newComment ***', this.postId, this.newComment);
      let comment = {
        comment: this.newComment.trim(),
        date: this.commentDate
      };
      // console.log('*** SinglePost >> leaveAComment() >> finna leave a new comment on postId ***', this.postId, comment);
      const commentWasPosted = await createOnePostComment(this.uId, this.token, this.postId, comment);
      if (commentWasPosted) {
        await updateDoluPosts(this.uId, this.token, generateNewDolu());
        const newId = commentWasPosted.name;
        this.post.comments = this.post.comments ? this.post.comments : {};
        this.post.comments[newId] = comment;
        this.newComment = '';
      }
    },
    async deleteOneComment(id) {
      console.log('*** SinglePost >> deleteOneComment() >> postId, commentId ***', this.postId, id);
      await deleteOnePostComment(this.uId, this.token, this.postId, id);
      await updateDoluPosts(this.uId, this.token, generateNewDolu());
      delete this.post.comments[id];
    },
    sharePost() {
      let shareUrl = '';

      // format depending on post type
      if (this.post.type === 'youtube') {
        shareUrl = `https://www.youtube.com/watch?v=${this.post.src}`;
      } else if (this.post.type === "imgur") {
        shareUrl = `https://imgur.com/${this.post.src}`; // imgur direct link
      }

      if (navigator.share) {
        navigator.share({ url: shareUrl });
      } else {
        // create SMS link
        const messageBody = encodeURIComponent(`Check this out: ${shareUrl}`);
        // const smsLink = `sms:?body=${messageBody}`;
        // window.location.href = smsLink;
        window.location.href = `sms:?body=${messageBody}`;
      }
    },
  },
  async mounted() {
    this.post = {...this.propPost};
    if (this.post.startTime) {
      this.youTubeStartTime = `&start=${this.post.startTime}`;
    }
    await this.cancelEditPost(); // using this method to set the form values to this.post/propPost
    // this.post.comments = ['a', 'b', 'c'];
    // this.post.likes = 22;
    // console.log('*** SinglePost >> this.post ***', this.post, this.youTubeStartTime);
    this.loadImgurScript();

    console.log('*** SinglePost >> mounted >> this.post ***', this.post);
  },
  updated() {
    if (this.post.type === 'imgur') {
      this.loadImgurScript();
    }
  },
}
</script>

<template>
  <div :id="`single-post-${postId}`" class="mb-16">
    <!-- EDIT THE POST -->
    <v-dialog v-model="showForm" fullscreen persistent>
      <v-card class="pa-4 bg-grey-lighten-4">
        <div id="edit-this-post-container">
          <h3 class="mb-3">Edit this Post</h3>

          <p class="mb-1">Post type: {{post.type}}</p>
          <p class="mb-3"><a :href="`https://imgur.com/${post.src}`" target="_blank">{{post.src}}</a></p>
          <!-- YouTube Start Time -->
          <div>
            <v-textarea v-if="post.type === 'youtube'"
              id="new-post-youtube-start-time"
              v-model="formStartTime"
              rows="1"
              auto-grow
              variant="outlined"
              label="Start Time (optional)"
            ></v-textarea>
            <!-- post.categories -->
            <v-combobox
              v-model="formCategories"
              :items="Object.keys(allCategoriesByName)"
              label="Categories (select multiple)"
              content-class="combobox-menu-limited"
              :menu-props="{ location: 'top', maxHeight: 250 }"
              chips
              multiple
            ></v-combobox>
          </div>
          <!-- Actions -->
          <div class="edit-post-actions d-flex justify-space-between">
            <v-btn @click.prevent="cancelEditPost" color="blue-lighten-1">cancel</v-btn>
            <v-btn @click.prevent="deletePost" color="red-lighten-2">Delete</v-btn>
            <v-btn @click.prevent="updatePost" color="green-lighten-1">Save</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>


    <!-- VIEW THE POST -->
    <div v-if="!showForm" class="single-post-view-container">

      <div @touchstart="handleTouch">
        <iframe v-if="post.type === 'youtube'"
          :src="`https://www.youtube.com/embed/${post.src}?autoplay=0${youTubeStartTime}&loop=1&playlist=${post.src}&mute=1&cc_load_policy=1`"
          class="iframe-youtube"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <blockquote v-if="post.type === 'imgur'"
          class="imgur-embed-pub"
          lang="en"
          :data-id="`${post.src}`"
          data-context="false"
        ><a :href="`https://imgur.com/${post.src}`"></a></blockquote>
      </div>

      <div v-if="post.type === 'youtube'" class="post-spacer-for-actions">&nbsp;</div>

      <div class="post-actions d-flex align-end justify-space-between my-3">
        <div class="d-flex justify-start align-center">
          <div v-if="postLiked" @click="doubleTappedThisPost"><v-icon>mdi-heart</v-icon></div>
          <v-icon v-else @click="doubleTappedThisPost">mdi-heart-outline</v-icon>
          <p v-if="post.likes" class="ml-2">{{post.likes}}</p>
        </div>
        <div class="d-flex justify-start align-center">
          <v-icon @click="showCommentsSection = !showCommentsSection">mdi-message-reply-outline</v-icon>
          <p v-if="post.comments" class="ml-2">{{Object.keys(post.comments).length}}</p>
        </div>
        <div>
          <v-icon @click="sharePost" style="font-size: 28px;">mdi-share-outline</v-icon>
        </div>
        <div>
          <v-icon @click="userClickedEdit">mdi-menu</v-icon>
        </div>
      </div>

      <div v-if="showCommentsSection" class="single-post-comments-section">
        <div class="d-flex">
          <v-textarea
            v-model="newComment"
            :rules="[v => v.length <= 256 || 'Max 256 characters']"
            counter
            variant="outlined"
            rows="1"
            auto-grow
            label="Leave a comment"
          ></v-textarea>
          <v-icon @click="leaveAComment" :color="newComment && newComment.length <= 256 ? 'blue-darken-1' : 'grey'" class="mt-auto mb-9 ml-1">mdi-send</v-icon>
        </div>
        <p @click="showCommentsSection = false" class="text-body-2 mb-3 text-center text-grey-lighten-2 cursor-pointer"><i>- hide comments -</i></p>

        <div v-if="post.comments" class="px-3 comments-container">
          <div v-for="id of Object.keys(post.comments)" :key="id" class="mb-3">
            <p>{{post.comments[id].comment}}</p>
            <div class="comments-meta d-flex justify-space-between">
              <p><i>{{post.comments[id].date}}</i></p>
              <v-icon @click="deleteOneComment(id)" color="red-lighten-1" class="cursor-pointer">mdi-delete-outline</v-icon>
            </div>
          </div>
        </div>
        <p @click="showCommentsSection = false" class="text-body-2 mt-3 text-center text-grey-lighten-2 cursor-pointer"><i>- hide comments -</i></p>
      </div>

    </div>


  </div>
</template>

<style scoped lang="scss">
#edit-this-post-container {
  padding-left: 16px;
  padding-right: 16px;
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    margin: 0 auto;
    width: 600px;
    max-width: 600px;
  }
}
.edit-post-actions {
  .v-btn {
    text-transform: capitalize;
  }
}
.combobox-menu-limited {
  max-height: 40vh !important;   /* only top 40% of screen */
  overflow-y: auto !important;   /* scroll inside the dropdown */
}
.single-post-view-container {
  position: relative;
  //max-width: 336px;
  max-width: 375px;
  max-height: 760px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  .post-spacer-for-actions { height: 600px; }
  .iframe-youtube {
    position: absolute;
    top: 0;
    left: 0;
    height: 600px;
    width: 100%;
  }
  .post-actions > div {
    width: 15%;
    padding-left: 5%;
  }
}
</style>
